module.exports = __webpack_public_path__ + "media/images/emblems/Gals-coat_of_arms-f14b8a4b2456a7f452f7b5a898dd0dd4.svg";